/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanAssetResponseDto
 */
export interface PlanAssetResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PlanAssetResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlanAssetResponseDto
     */
    planId: string;
    /**
     * 
     * @type {string}
     * @memberof PlanAssetResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof PlanAssetResponseDto
     */
    organizationId: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlanAssetResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PlanAssetResponseDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlanAssetResponseDto
     */
    assignedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlanAssetResponseDto
     */
    deactivatedAt?: Date | null;
}

/**
 * Check if a given object implements the PlanAssetResponseDto interface.
 */
export function instanceOfPlanAssetResponseDto(value: object): value is PlanAssetResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('planId' in value) || value['planId'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('assignedAt' in value) || value['assignedAt'] === undefined) return false;
    return true;
}

export function PlanAssetResponseDtoFromJSON(json: any): PlanAssetResponseDto {
    return PlanAssetResponseDtoFromJSONTyped(json, false);
}

export function PlanAssetResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanAssetResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'planId': json['planId'],
        'assetId': json['assetId'],
        'organizationId': json['organizationId'],
        'active': json['active'],
        'startDate': (new Date(json['startDate'])),
        'assignedAt': (new Date(json['assignedAt'])),
        'deactivatedAt': json['deactivatedAt'] == null ? undefined : (new Date(json['deactivatedAt'])),
    };
}

export function PlanAssetResponseDtoToJSON(json: any): PlanAssetResponseDto {
    return PlanAssetResponseDtoToJSONTyped(json, false);
}

export function PlanAssetResponseDtoToJSONTyped(value?: PlanAssetResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'planId': value['planId'],
        'assetId': value['assetId'],
        'organizationId': value['organizationId'],
        'active': value['active'],
        'startDate': value['startDate'].toISOString(),
        'assignedAt': value['assignedAt'].toISOString(),
        'deactivatedAt': value['deactivatedAt'] == null ? value['deactivatedAt'] : value['deactivatedAt'].toISOString(),
    };
}

